export const TEMPLATE_TYPES = {
  SINGLE_MALT: 'singleMalt',
  LIMITED_RELEASE: 'limitedRelease',
  SINGLE_CASK: 'singleCask'
};
